import React from 'react';
import {BrowserRouter, Route} from 'react-router-dom';

/* Paginas */
import Site from './site/site.jsx';
import Login from './app/Login/login.jsx';
import NovoCliente from './app/NovoCliente/novocliente.jsx';
import ResetaSenha from './app/ResetaSenha/resetasenha.jsx';
import Home from './app/Home/home.jsx';
import Tutorial from './app/Tutorial/tutorial.jsx';
import Historico from './app/Historico/historico.jsx';
import Emissao from './app/Emissao/emissao.jsx';
import Renovacao from './app/Renovacao/renovacao.jsx';

function App(){
    return <BrowserRouter>
    <Route exact path='/' component={Site} />    
    <Route exact path='/app' component={Login} />    
    <Route exact path='/app/novocliente' component={NovoCliente} />  
    <Route exact path='/app/resetasenha' component={ResetaSenha} /> 
    <Route exact path='/app/home' component={Home} /> 
    <Route exact path='/app/tutorial' component={Tutorial} /> 
    <Route exact path='/app/historico' component={Historico} /> 
    <Route exact path='/app/emissao' component={Emissao} /> 
    <Route exact path='/app/renovacao' component={Renovacao} /> 
    </BrowserRouter>;
  }

export default App;